// // 测试网
// export const CONTRACT_ADDRESS = 'TFknwRDSdbg2cANXVwwfGTbbNpST9wVaoC'
// 主网

export const  CONTRACT_ADDRESS = 'TYTBeM2mUAWHoqvPGXQed3eNzFwqScW7sf'
//主网2
// export const  CONTRACT_ADDRESS = 'TDJDENjUFtS9R5QKetkGXEA931zNABK3UE'